import React, { useState, useEffect } from "react";
import { userService } from "../../../_services";
import { FormDialog } from "@/components/ui/form-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle, AlertCircle } from "lucide-react";

/**
 * Add/Edit Training Module Modal
 * Modernized with shadcn Dialog and Form components
 */
function AddEditTrainingModule({ hideModal, mode, moduleData, changeInModule }) {
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const [moduleTitle, setModuleTitle] = useState('');
    const [formError, setFormError] = useState('');
    const [formSuccess, setFormSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');
        setUserId(userId);
        setUserName(userName);

        if (moduleData && moduleData.moduleName) {
            setModuleTitle(moduleData.moduleName);
        }
    }, [moduleData]);

    const handleSubmit = async () => {
        setFormSuccess('');
        setFormError('');

        // Validation
        if (!moduleTitle || moduleTitle.trim() === '') {
            setFormError('Please add title');
            return;
        }

        if (moduleTitle.length > 50) {
            setFormError('Module name can be max. 50 characters long');
            return;
        }

        setLoading(true);

        try {
            let postdata;
            
            if (mode === 'ADD') {
                postdata = await userService.CreateModule(userId, userName, moduleTitle.trim());
            } else if (mode === 'EDIT') {
                postdata = await userService.EditModule(userId, userName, moduleTitle.trim(), moduleData.objectUID);
            }

            if (postdata && postdata.length > 0) {
                if (postdata[0].code === '1') {
                    setFormSuccess(postdata[0].message);
                    changeInModule();
                    setTimeout(() => {
                        hideModal();
                    }, 1000);
                } else {
                    setFormError(postdata[0].message);
                }
            }
        } catch (error) {
            setFormError('An error occurred. Please try again.');
            console.error('Error saving module:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        hideModal();
    };

    return (
        <FormDialog
            open={true}
            onOpenChange={handleClose}
            title={`${mode === 'EDIT' ? 'Edit' : 'Add'} Training Module`}
            description="Enter a descriptive title for the training module (max 50 characters)"
            onSubmit={handleSubmit}
            onCancel={handleClose}
            submitText={`${mode === 'EDIT' ? 'Update' : 'Add'} Module`}
            loading={loading}
            maxWidth="md"
        >
            <div className="space-y-4">
                <div className="space-y-2">
                    <Label htmlFor="moduleTitle">Module Title</Label>
                    <Input
                        id="moduleTitle"
                        type="text"
                        value={moduleTitle}
                        onChange={(e) => setModuleTitle(e.target.value)}
                        placeholder="Enter module title"
                        maxLength={50}
                        className={formError ? "border-destructive" : ""}
                    />
                    <p className="text-xs text-primary/70">
                        {moduleTitle.length}/50 characters
                    </p>
                </div>

                {/* Error Message */}
                {formError && (
                    <Alert variant="destructive">
                        <AlertCircle className="h-4 w-4" />
                        <AlertDescription>{formError}</AlertDescription>
                    </Alert>
                )}

                {/* Success Message */}
                {formSuccess && (
                    <Alert variant="success">
                        <CheckCircle className="h-4 w-4" />
                        <AlertDescription>{formSuccess}</AlertDescription>
                    </Alert>
                )}
            </div>
        </FormDialog>
    );
}

export default AddEditTrainingModule;

